import { render, staticRenderFns } from "./MenuConfig.vue?vue&type=template&id=0d387d8d"
import script from "./MenuConfig.vue?vue&type=script&lang=js"
export * from "./MenuConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports